const RANK = (value: number, { _data: data }: { _data: number[] }): number =>
  Array.from(new Set(data))
    .sort((a, b) => b - a)
    .indexOf(value) + 1;

export default RANK;
